import React from 'react';
import customStatusStyles from './customstatus.module.css';
import { Box, Grid, Switch, Avatar, Stack, Typography } from '@mui/material';
import { StyledCard, StyledCardTitle, FlexDiv, CustomButton } from '../../../../../../../custom/components';
import CronModal from './CronModal';
import StatusModal from './StatusModal';

const CustomStatus = (props) => {

  const airlineList = props.airlineList || [];
  const enabledCount = (props.customStatus || []).filter((status) => status.value).length;
  const disabledCount = airlineList.length - enabledCount;
  const apiCallCount = props.apiCallCount?.total_api_calls;

  return (
    <div>
      <Grid container direction={'row'} spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <FlexDiv className={customStatusStyles.headerRow}>
              <StyledCardTitle>Customs Status</StyledCardTitle>
              <Stack direction={'row'} spacing={2} alignItems={'center'}>
                <CustomButton variant='contained' onClick={() => props.handleOpen('status')} className={customStatusStyles.cronButton}>
                Define Customs Status
                </CustomButton>
                <CustomButton variant='contained' onClick={() => props.handleOpen('cron')} className={customStatusStyles.cronButton}>
                Set Recheck Interval
                </CustomButton>
              </Stack>
            </FlexDiv>
            <Typography className={customStatusStyles.subTitle}>
              Toggle airline-level customs status availability.
            </Typography>

            <Grid container spacing={3} className={customStatusStyles.layoutGrid}>
              <Grid item xs={12} md={4} lg={3}>
                <Box component='div' className={customStatusStyles.insightPanel}>
                  <Typography className={customStatusStyles.insightTitle}>Status Overview</Typography>
                  <Box component='div' className={customStatusStyles.metricGrid}>
                    <Box component='div' className={customStatusStyles.metricCard}>
                      <Typography className={customStatusStyles.metricValue}>{airlineList.length}</Typography>
                      <Typography className={customStatusStyles.metricLabel}>Total Airlines</Typography>
                    </Box>
                    <Box component='div' className={customStatusStyles.metricCard}>
                      <Typography className={customStatusStyles.metricValue}>{enabledCount}</Typography>
                      <Typography className={customStatusStyles.metricLabel}>Enabled</Typography>
                    </Box>
                    <Box component='div' className={customStatusStyles.metricCard}>
                      <Typography className={customStatusStyles.metricValue}>{disabledCount}</Typography>
                      <Typography className={customStatusStyles.metricLabel}>Disabled</Typography>
                    </Box>
                    <Box component='div' className={`${customStatusStyles.metricCard} ${customStatusStyles.billingMetric}`}>
                      <Typography className={customStatusStyles.metricValue}>
                        {apiCallCount !== null && apiCallCount !== undefined ? apiCallCount.toLocaleString() : ' '}
                      </Typography>
                      <Typography className={customStatusStyles.metricLabel}>TOTAL API CALLS MADE</Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={8} lg={9}>
                <Grid container spacing={2.5} className={customStatusStyles.gridContainer}>
                  {airlineList.map((airline) => {
                    const isEnabled = props.customStatus.find((status) => status.airlineId === airline.id)?.value;

                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        key={airline.id}
                        className={`${customStatusStyles.gridItem}`}
                      >
                        <Box component='div' className={customStatusStyles.airlineInfoContainer}>
                          <Stack direction={'column'} spacing={2}>
                            <Stack direction={'row'} alignItems={'center'} spacing={2} className={customStatusStyles.topRow}>
                              <Avatar className={customStatusStyles.avatar}>{airline.code}</Avatar>
                              <Box component='div'>
                                <Typography className={customStatusStyles.code}>{airline.name}</Typography>
                                <Typography className={customStatusStyles.airlineTag}>Airline</Typography>
                              </Box>
                            </Stack>

                            <Stack direction={'row'} alignItems={'center'} justifyContent='space-between' spacing={1} className={customStatusStyles.bottomRow}>
                              {isEnabled ?
                                <Box component='div' className={`${customStatusStyles.status} ${customStatusStyles.enabled}`}>Enabled</Box>
                                :
                                <Box component='div' className={`${customStatusStyles.status} ${customStatusStyles.disabled}`}>Disabled</Box>
                              }
                              <Switch
                                name={airline.id}
                                size='small'
                                defaultChecked={isEnabled}
                                onChange={props.onChange}
                                className={customStatusStyles.switch}
                                classes={{
                                  switchBase: customStatusStyles.switchBase,
                                  checked: customStatusStyles.switchChecked,
                                  track: customStatusStyles.switchTrack,
                                  thumb: customStatusStyles.switchThumb,
                                }}
                              />
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
            <CronModal
              modal={props.modal}
              onClose={props.onClose}
              cron={props.cron}
              cron_period={props.cron_period}
              cron_code={props.cron_code}
              cron_spl={props.cron_spl}
              cron_spl_code={props.cron_spl_code}
              cron_spl_period={props.cron_spl_period}
              cron_spl_interval={props.cron_spl_interval}
              onChangeCron={props.onChangeCron}
              saveCronInterval={props.saveCronInterval}
              cronErrors={props.cronErrors}
            />
            <StatusModal
              modal={props.modal}
              onClose={props.onClose}
              marked_as_cleared={props.marked_as_cleared}
              marked_as_not_cleared={props.marked_as_not_cleared}
              onChangeStatus={props.onChangeStatus}
              saveStatus={props.saveStatus}
              statusErrors={props.statusErrors}
            />
          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomStatus;